/**
 * @return {string}
 */
module.exports = function StringToPath(str) {
  return encodeURI(str.replace(/\s/g, "-"));
};